import styled from 'styled-components';
import { colors } from '../colors';

interface textareaProps {
	borderColor?: string;
	height?: string;
}

const Textarea = styled.textarea<textareaProps>`
	display: inline-block;
	width: 100%;
	background: ${colors.White};
	border: 1px solid ${colors.GreyA0};
	border-radius: 1px;
	height: 36px;
	padding: 16px;
	font-size: 14px;
	transition: ease-in all 0.4s;
	box-sizing: border-box;
	color: ${colors.Grey};
	height: ${({ height }) => height}!important;
	border-color: ${({ borderColor }) => borderColor}!important;
	:focus {
		outline: none;
		border: 1px solid ${colors.BlueDark};
	}
`;

export default Textarea;
